import {HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {Injectable, Injector} from '@angular/core';
import {isNil} from 'lodash';
import {AppUser} from '../../models/security/app_user';
import {environment} from '../../../environments/environment';
import {ClientSettingsService} from '../../services/settings/client-settings.service';
import {SecurityService} from '../../services/settings/security.service';
import {Router} from '@angular/router';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {
  private skipUrls = ['/assets'];

  constructor(private injector: Injector) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let req = request;
    if (this.skipUrls.some(url => req.url.startsWith(url))) {
      // console.warn(`Skipping HTTP interceptor za url: ${req.url}...`);
      return next.handle(req);
    }

    if (localStorage.getItem('loggedUser')) {
      const authUser: AppUser = JSON.parse(localStorage.getItem('loggedUser')) as AppUser;
      req = request.clone({
        withCredentials: true,
        headers: !isNil(request.headers) ? request.headers.set('Authorization', 'Bearer ' + authUser.accessToken) :
                                           new HttpHeaders().set('Authorization', 'Bearer ' + authUser.accessToken)
      });
    }

    const settingsSvc = this.getClientSettingsService();
    if (!isNil(settingsSvc.getActiveStockroom()) && !isNil(settingsSvc.getActiveCompany())) {
      const hdrs = !isNil(req.headers) ? req.headers.set('X-BMS-Active-Company-Id', settingsSvc.getActiveCompany().id)
                                                                .set('X-BMS-Active-Stockroom-Id', settingsSvc.getActiveStockroom().id) :
                                                     new HttpHeaders().set('X-BMS-Active-Company-Id', settingsSvc.getActiveCompany().id)
                                                                      .set('X-BMS-Active-Stockroom-Id', settingsSvc.getActiveStockroom().id);
      req = req.clone({ headers: hdrs });
    } else {
      console.error('Nema magacina ni kompanije');
      if (!this.getRouter().url.startsWith('/ng/home')) {
        this.getRouter().navigate(['ng/home']);
      }
    }

    return next.handle(req).pipe(catchError(err => {
      if (!environment.production) {
        console.error(req);
        console.error(err.url + ', ' + err.status);
      }

      if (/ng\/login$/.test(err.url) || err.status === 302 || err.status === 401) {
        // auto logout if 401 response returned from api
        this.getSecurityService().logout();
        if (! (/auth\/login$/.test(req.url))) {
          location.reload();
        }
      }

      // const error = err.error.message || err.statusText;
      return throwError(err);
    }));
  }

  private getClientSettingsService(): ClientSettingsService {
    return this.injector.get(ClientSettingsService);
  }

  private getSecurityService(): SecurityService {
    return this.injector.get(SecurityService);
  }

  private getRouter(): Router {
    return this.injector.get(Router);
  }
}
